(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1000px)');

  function attachSharedMegaQuickActions(menu) {
    var shared = document.getElementById('tcb-shared-mega-quick-actions');
    var aside = menu && menu.querySelector('.mega-menu__aside');
    if (!shared || !aside || !menu.classList.contains('mega-menu')) return;
    if (shared.parentNode !== aside) {
      aside.insertBefore(shared, aside.firstChild);
    }
    shared.removeAttribute('hidden');
    shared.setAttribute('aria-hidden', 'false');
  }

  function detachSharedMegaQuickActions() {
    var shared = document.getElementById('tcb-shared-mega-quick-actions');
    var portal = document.getElementById('tcb-nav-panel-portal');
    if (!shared || !portal) return;
    if (shared.parentNode !== portal) {
      portal.insertBefore(shared, portal.firstChild);
    }
    shared.setAttribute('hidden', '');
    shared.setAttribute('aria-hidden', 'true');
  }

  function anyMegaMenuOpen() {
    return !!document.querySelector('.mega-menu.is-dropdown-open[aria-hidden="false"]');
  }

  function syncMenuHidden(menu, isOpen) {
    if (!menu) return;
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) {
      menu.removeAttribute('hidden');
      menu.removeAttribute('inert');
    } else {
      menu.setAttribute('hidden', '');
      if (menu.classList.contains('is-nested') || menu.classList.contains('mega-menu') || menu.classList.contains('nav-dropdown')) {
        menu.setAttribute('inert', '');
      }
    }
  }

  function navBarBottom() {
    var bar = document.querySelector('[data-tcb-desktop-nav-bar]');
    if (!bar) return 0;
    // ponytail: fixed mega menus use viewport coordinates — never add scrollY
    return bar.getBoundingClientRect().bottom;
  }

  function positionMegaMenu(menu) {
    if (!menu || !menu.classList.contains('mega-menu')) return;
    var top = navBarBottom();
    var maxH = Math.max(280, window.innerHeight - top - 8);
    menu.style.setProperty('--tcb-mega-top', top + 'px');
    menu.style.setProperty('--tcb-mega-max-height', maxH + 'px');
    menu.style.maxHeight = maxH + 'px';
  }

  function restoreMobileMenu() {
    var menu = document.getElementById('mobile-menu');
    var nav = document.querySelector('[data-tcb-mobile-nav]');
    if (menu && nav && !nav.contains(menu)) {
      nav.appendChild(menu);
    }
  }

  function initMobileMenuSync() {
    var menu = document.getElementById('mobile-menu');
    if (!menu || menu.getAttribute('data-tcb-mobile-sync') === '1') return;
    menu.setAttribute('data-tcb-mobile-sync', '1');

    function syncMobileMenuHidden() {
      var open = menu.getAttribute('aria-hidden') === 'false';
      if (open) {
        menu.removeAttribute('hidden');
        menu.removeAttribute('inert');
      } else if (menu.hasAttribute('hidden')) {
        menu.removeAttribute('hidden');
      }
    }

    var toggle = document.querySelector('[aria-controls="mobile-menu"]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        window.setTimeout(syncMobileMenuHidden, 0);
      });
    }

    syncMobileMenuHidden();
    if ('MutationObserver' in window) {
      new MutationObserver(syncMobileMenuHidden).observe(menu, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    }
  }

  function relocateNavPanels() {
    restoreMobileMenu();
    var portal = document.getElementById('tcb-nav-panel-portal');
    if (!portal || portal.getAttribute('data-tcb-portal-ready') === '1') return;
    portal.removeAttribute('hidden');
    portal.setAttribute('aria-hidden', 'false');

    document.querySelectorAll('.nav-bar .mega-menu, .nav-bar > .nav-dropdown, .header__desktop-nav .nav-dropdown').forEach(function (panel) {
      if (panel.closest('#tcb-nav-panel-portal')) return;
      var owner = panel.closest('.nav-bar__item, .header__desktop-nav, [data-tcb-mobile-nav]');
      if (owner) {
        panel.setAttribute('data-tcb-nav-owner', owner.className || 'nav');
        if (panel.classList.contains('mega-menu') && owner.classList.contains('nav-bar__item')) {
          owner.classList.add('nav-bar__item--static');
        }
      }
      portal.appendChild(panel);
    });

    portal.setAttribute('data-tcb-portal-ready', '1');
    initMobileMenuSync();
  }

  function syncNavExposure() {
    var isDesktop = DESKTOP_MQ.matches;
    var mobileNav = document.querySelector('[data-tcb-mobile-nav]');
    var mobileMenu = document.getElementById('mobile-menu');
    var desktopBar = document.querySelector('[data-tcb-desktop-nav-bar]');

    if (mobileNav) {
      mobileNav.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
    }
    if (mobileMenu && isDesktop) {
      mobileMenu.setAttribute('aria-hidden', 'true');
    }
    if (desktopBar) {
      desktopBar.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
    }
  }

  function initMegaMenuLabels() {
    document.querySelectorAll('.mega-menu__promo-image, .mega-menu__column-image, .nav-bar img, .mobile-menu img, .header img, .mega-menu img').forEach(function (img) {
      if (img.closest('[data-tcb-promo-img], .mega-menu__promo-media, .mega-menu__promo--card')) return;
      var alt = img.getAttribute('alt');
      if (alt === null || alt === '' || alt.toLowerCase() === 'image') {
        if (!img.closest('[data-tcb-package-included], .tcb-fah, .tcb-equipment-finder, .tcb-not-found-card')) {
          img.setAttribute('alt', '');
          img.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function markDecorativeImages() {
    document.querySelectorAll('img[alt=""], img:not([alt])').forEach(function (img) {
      if (img.getAttribute('data-tcb-alt-fixed') === '1') return;
      var rect = img.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return;
      var label = (img.getAttribute('aria-label') || img.getAttribute('title') || '').trim();
      var inInformative = img.closest('a[aria-label], figure, .tcb-not-found-card, .tcb-fah, .tcb-equipment-finder, [data-tcb-package-included]');
      if (inInformative && label) {
        img.setAttribute('alt', label);
        img.setAttribute('data-tcb-alt-fixed', '1');
        return;
      }
      if (img.closest('[aria-hidden="true"]')) return;
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('data-tcb-alt-fixed', '1');
    });
  }

  function setHeaderHeight() {
    var header = document.querySelector('[data-section-type="header"]');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
    }
  }

  function fixHashActionLinks() {
    document.querySelectorAll('a[href="#"]').forEach(function (link) {
      if (link.getAttribute('data-tcb-hash-fixed') === '1') return;
      var rect = link.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return;
      var label = (link.textContent || link.getAttribute('aria-label') || '').trim();
      if (!label) return;
      var lower = label.toLowerCase();
      var inPayment = link.closest('.tcb-payment-terms-wrap, .shopify-payment-terms, shopify-payment-terms, .shopify-payment-button, more-payment-options-link');
      var isReview = /write\s*a?\s*review/i.test(label) || link.closest('.jdgm, .tcb-reviews-v2');
      var isPaymentMore = /more payment options|payment options/i.test(lower) ||
        link.classList.contains('shopify-payment-button__more-options') ||
        !!link.closest('more-payment-options-link');

      if (!inPayment && !isReview && !isPaymentMore) return;

      link.setAttribute('data-tcb-hash-fixed', '1');

      if (isReview) {
        link.setAttribute('href', '#tcb-pdp-reviews');
        if (link.tagName === 'A') {
          link.setAttribute('role', 'button');
          link.addEventListener('click', function (e) {
            e.preventDefault();
          });
        }
        return;
      }

      if (inPayment || isPaymentMore) {
        link.setAttribute('href', '#tcb-financing');
        link.classList.add('tcb-hash-action--visually-hidden');
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function initMenuHoverDelay() {
    if (!DESKTOP_MQ.matches) return;
    var bar = document.querySelector('[data-tcb-desktop-nav-bar]');
    if (!bar || bar.getAttribute('data-tcb-menu-delay') === '1') return;
    bar.setAttribute('data-tcb-menu-delay', '1');

    // ponytail: block theme.js instant mouseover/mouseout; we open after a short dwell
    var OPEN_DELAY = 320;
    var CLOSE_DELAY = 150;

    bar.addEventListener(
      'mouseover',
      function (e) {
        if (e.target.closest('.nav-bar__item .nav-dropdown, .nav-bar__item .mega-menu')) return;
        if (e.target.closest('.nav-bar__item [aria-haspopup="true"]')) {
          e.stopImmediatePropagation();
        }
      },
      true
    );

    bar.addEventListener(
      'mouseout',
      function (e) {
        if (e.target.closest('.nav-bar__item.is-dropdown-open')) {
          e.stopImmediatePropagation();
        }
      },
      true
    );

    bar.querySelectorAll('.nav-bar__item').forEach(function (item) {
      var trigger = item.querySelector('[data-type="menuitem"][aria-haspopup="true"]');
      var menuId = trigger ? trigger.getAttribute('aria-controls') : '';
      var menu = menuId ? document.getElementById(menuId) : item.querySelector('.nav-dropdown, .mega-menu');
      if (!trigger || !menu) return;

      var openTimer = null;
      var closeTimer = null;

      function isPointerInDropdown(target) {
        return !!(target && (item.contains(target) || menu.contains(target)));
      }

      function openMenu() {
        clearTimeout(closeTimer);
        closeTimer = null;
        trigger.setAttribute('aria-expanded', 'true');
        item.classList.add('is-dropdown-open');
        menu.classList.add('is-dropdown-open');
        syncMenuHidden(menu, true);
        positionMegaMenu(menu);
        attachSharedMegaQuickActions(menu);
      }

      function closeMenu() {
        clearTimeout(openTimer);
        openTimer = null;
        trigger.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-dropdown-open');
        menu.classList.remove('is-dropdown-open');
        syncMenuHidden(menu, false);
        if (!anyMegaMenuOpen()) detachSharedMegaQuickActions();
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
      }

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeTimer = null;
        if (item.classList.contains('is-dropdown-open')) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(openMenu, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function (e) {
        if (isPointerInDropdown(e.relatedTarget)) return;
        clearTimeout(openTimer);
        openTimer = null;
        scheduleClose();
      });

      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeTimer = null;
      });

      menu.addEventListener('mouseleave', function (e) {
        if (isPointerInDropdown(e.relatedTarget)) return;
        scheduleClose();
      });
    });
  }

  function initDesktopNavKeyboard() {
    if (!DESKTOP_MQ.matches) return;
    var bar = document.querySelector('[data-tcb-desktop-nav-bar]');
    if (!bar) return;

    bar.querySelectorAll('.nav-bar__item').forEach(function (item) {
      var trigger = item.querySelector('[data-type="menuitem"][aria-haspopup="true"]');
      var menuId = trigger ? trigger.getAttribute('aria-controls') : '';
      var menu = menuId ? document.getElementById(menuId) : item.querySelector('.nav-dropdown, .mega-menu');
      if (!trigger || !menu || item.getAttribute('data-tcb-nav-bound') === '1') return;
      item.setAttribute('data-tcb-nav-bound', '1');

      function openMenu() {
        trigger.setAttribute('aria-expanded', 'true');
        item.classList.add('is-dropdown-open');
        menu.classList.add('is-dropdown-open');
        syncMenuHidden(menu, true);
        positionMegaMenu(menu);
        attachSharedMegaQuickActions(menu);
      }

      function closeMenu() {
        trigger.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-dropdown-open');
        menu.classList.remove('is-dropdown-open');
        syncMenuHidden(menu, false);
        if (!anyMegaMenuOpen()) detachSharedMegaQuickActions();
      }

      item.addEventListener('focusin', openMenu);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMenu();
      });
    });
  }

  function initMobilePanelSync() {
    var nav = document.querySelector('[data-tcb-mobile-nav]');
    if (!nav || nav.getAttribute('data-tcb-panel-sync') === '1') return;
    nav.setAttribute('data-tcb-panel-sync', '1');

    nav.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-action="open-panel"]');
      if (!openBtn) return;
      var panelId = openBtn.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);
      if (panel) {
        panel.removeAttribute('hidden');
        panel.removeAttribute('inert');
      }
    });
  }

  function boot() {
    restoreMobileMenu();
    initMobileMenuSync();
    initMobilePanelSync();
    relocateNavPanels();
    syncNavExposure();
    initMegaMenuLabels();
    markDecorativeImages();
    initMenuHoverDelay();
    initDesktopNavKeyboard();
    fixHashActionLinks();
    setHeaderHeight();
    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', function () {
        restoreMobileMenu();
        syncNavExposure();
        initMenuHoverDelay();
        initDesktopNavKeyboard();
      });
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(function () {
        restoreMobileMenu();
        syncNavExposure();
        initMenuHoverDelay();
        initDesktopNavKeyboard();
      });
    }
    window.addEventListener('resize', function () {
      setHeaderHeight();
      document.querySelectorAll('.mega-menu[aria-hidden="false"]').forEach(positionMegaMenu);
    });
    window.setTimeout(fixHashActionLinks, 1200);
    window.setTimeout(fixHashActionLinks, 4000);
    window.setTimeout(markDecorativeImages, 500);
    window.setTimeout(markDecorativeImages, 2000);
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        fixHashActionLinks();
        markDecorativeImages();
        initMegaMenuLabels();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
